import { render, staticRenderFns } from "./my_demand.vue?vue&type=template&id=aa91d710&scoped=true"
import script from "./my_demand.vue?vue&type=script&lang=js"
export * from "./my_demand.vue?vue&type=script&lang=js"
import style0 from "./my_demand.vue?vue&type=style&index=0&id=aa91d710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa91d710",
  null
  
)

export default component.exports